import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/icon/ck.svg'


const _withScopeId = n => (_pushScopeId("data-v-09e42dd8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "single-course-area ptb-100"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-8 col-md-12" }
const _hoisted_5 = { class: "single-course-desc" }
const _hoisted_6 = { class: "single-course-image" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "single-course-content" }
const _hoisted_9 = { class: "course-catgy" }
const _hoisted_10 = { class: "user-details" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Eğitmen :", -1))
const _hoisted_12 = { class: "course-tabs" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("nav", null, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "nav course-nav",
    id: "nav-tab",
    role: "tablist"
  }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "course-link active",
      id: "nav-overview-tab",
      "data-bs-toggle": "tab",
      "data-bs-target": "#nav-overview",
      type: "button",
      role: "tab",
      "aria-controls": "nav-overview",
      "aria-selected": "true"
    }, " Genel "),
    /*#__PURE__*/_createElementVNode("button", {
      class: "course-link",
      id: "nav-carriculum-tab",
      "data-bs-toggle": "tab",
      "data-bs-target": "#nav-carriculum",
      type: "button",
      role: "tab",
      "aria-controls": "nav-carriculum",
      "aria-selected": "false"
    }, " Müfredat "),
    /*#__PURE__*/_createElementVNode("button", {
      class: "course-link",
      id: "nav-instructor-tab",
      "data-bs-toggle": "tab",
      "data-bs-target": "#nav-instructor",
      type: "button",
      role: "tab",
      "aria-controls": "nav-instructor",
      "aria-selected": "false"
    }, " Eğitmen ")
  ])
], -1))
const _hoisted_14 = {
  class: "single-course-tab",
  id: "nav-tabContent"
}
const _hoisted_15 = {
  class: "overview-panel fade active show",
  id: "nav-overview",
  role: "tabpanel",
  "aria-labelledby": "nav-overview-tab"
}
const _hoisted_16 = { class: "overview-content cmb-30" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "course-desc-heading" }, "Kurs Açıklaması", -1))
const _hoisted_18 = { class: "overview-otp cmb-30" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "course-desc-heading" }, "Ne Öğreneceksiniz?", -1))
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "course-single-otp" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "icon"
}, null, -1))
const _hoisted_23 = { class: "overview-extra" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "course-desc-heading" }, "Ekstra Olanaklar!", -1))
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "extra-otp" }
const _hoisted_27 = ["src"]
const _hoisted_28 = {
  class: "carriculum-panel fade",
  id: "nav-carriculum",
  role: "tabpanel",
  "aria-labelledby": "nav-carriculum-tab"
}
const _hoisted_29 = { class: "carriculum-content cmb-30" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "course-desc-heading" }, "Müfredat", -1))
const _hoisted_31 = {
  class: "instructor-panel fade",
  id: "nav-instructor",
  role: "tabpanel",
  "aria-labelledby": "nav-instructor-tab"
}
const _hoisted_32 = { class: "single-instructor-content" }
const _hoisted_33 = { class: "row" }
const _hoisted_34 = { class: "col-lg-5" }
const _hoisted_35 = { class: "instructor-img" }
const _hoisted_36 = ["src", "alt"]
const _hoisted_37 = { class: "col-lg-7" }
const _hoisted_38 = { class: "single-instructor-info" }
const _hoisted_39 = { class: "sub-title" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "reviews-panel fade",
  id: "nav-reviews",
  role: "tabpanel",
  "aria-labelledby": "nav-reviews-tab"
}, [
  /*#__PURE__*/_createElementVNode("h3", null, "Reviews Section")
], -1))
const _hoisted_41 = { class: "col-lg-4 col-md-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CourseSidebar = _resolveComponent("CourseSidebar")!

  return (_ctx.course)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("img", {
                    src: _ctx.course.image,
                    alt: _ctx.course.title
                  }, null, 8, _hoisted_7)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.course.category), 1),
                  _createElementVNode("h2", null, _toDisplayString(_ctx.course.title), 1),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("p", null, [
                      _hoisted_11,
                      _createTextVNode(" " + _toDisplayString(_ctx.course.instructor.name), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _hoisted_17,
                        _createElementVNode("p", null, _toDisplayString(_ctx.course.description), 1)
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _hoisted_19,
                        _createElementVNode("div", _hoisted_20, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.course.whatYouWillLearn, (item, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "col-lg-6 col-md-12 col-sm-12",
                              key: index
                            }, [
                              _createElementVNode("div", _hoisted_21, [
                                _hoisted_22,
                                _createElementVNode("p", null, _toDisplayString(item), 1)
                              ])
                            ]))
                          }), 128))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _hoisted_24,
                        _createElementVNode("div", _hoisted_25, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.course.extraFacilities, (facility, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "col-lg-4",
                              key: index
                            }, [
                              _createElementVNode("div", _hoisted_26, [
                                _createElementVNode("img", {
                                  src: facility.icon,
                                  alt: "icon"
                                }, null, 8, _hoisted_27),
                                _createElementVNode("p", null, _toDisplayString(facility.text), 1)
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _hoisted_30,
                        _createElementVNode("ul", null, [
                          _createElementVNode("li", null, [
                            _createElementVNode("p", null, "Seviye: " + _toDisplayString(_ctx.course.level), 1)
                          ]),
                          _createElementVNode("li", null, [
                            _createElementVNode("p", null, _toDisplayString(_ctx.course.lessons) + " Ders Sayısı/Oturum", 1)
                          ]),
                          _createElementVNode("li", null, [
                            _createElementVNode("p", null, "Toplam Süre: " + _toDisplayString(_ctx.course.duration), 1)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("div", _hoisted_35, [
                              _createElementVNode("img", {
                                src: _ctx.course.instructor.image,
                                alt: _ctx.course.instructor.name
                              }, null, 8, _hoisted_36)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("div", _hoisted_38, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.course.instructor.name), 1),
                              _createElementVNode("p", _hoisted_39, _toDisplayString(_ctx.course.instructor.title), 1),
                              _createElementVNode("p", null, _toDisplayString(_ctx.course.instructor.bio), 1)
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _hoisted_40
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_41, [
              _createVNode(_component_CourseSidebar, { course: _ctx.course }, null, 8, ["course"])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}